import classnames from 'classnames';
import React from 'react';
import { MAX_ROW_NUM } from '../../constants';
import Card from '../Card';
import CalendarNoDataCard from '../NoDataCard';

import type { IBaseProps } from '@home/types/common';
import type { ICalendarColCfgMapping } from '../../types';

interface ICalendarPanelCardListProps extends IBaseProps {
  // 全屏时，挂载节点
  fullScreenContent: React.RefObject<HTMLElement | null>;
  colCfgMapping?: ICalendarColCfgMapping;
  fold?: boolean;
  isStudioCalendar?: boolean;
  isDashboardCalendar?: boolean;
  currentTime?: string;
  dataList?: CommonCalendarDataTypes;
  getCalendarColMR?: (index: number) => number | string;
  getCalendarCardMR?: (colKey: string, index: number) => number | string;
  onCardBodyScroll?: (e: any) => void;
  onCardClick?:
    | ((cardList: CommonCalendarCardItemTypes | null, isJump: boolean) => string | undefined)
    | null;
}

const getCalendarPanelCardListKey = (key?: string) => `dbg-calendar-panel-card-list__${key}`;

const getCalendarPanelCardListItemKey = (parentKey?: string, key?: string) =>
  `dbg-calendar-panel-card-list-item__${parentKey}__${key}`;

const CalendarPanelCardList: React.ForwardRefRenderFunction<
  HTMLDivElement,
  ICalendarPanelCardListProps
> = (props, ref) => {
  const {
    style,
    className,
    fullScreenContent,
    colCfgMapping,
    fold = false,
    isStudioCalendar = false,
    isDashboardCalendar = false,
    currentTime = '',
    dataList = [],
    getCalendarColMR,
    getCalendarCardMR,
    onCardBodyScroll,
    onCardClick,
  } = props;

  return (
    <div
      ref={ref}
      style={style}
      className={classnames('dbg-schedule-calendar-body-main-context', className)}
      onScroll={onCardBodyScroll}
    >
      <div className="dbg-schedule-calendar-body-main-box">
        {dataList?.map((dataItem, dataItemIdx) => {
          const { date: dataItemDate, list: dataItemList } = dataItem || {};
          const isCurrentTimeCol = dataItemDate === currentTime;
          const dataItemListLen = dataItemList?.length || 0;
          const showCalendarCardList = dataItemListLen > 0;
          const dataItemColCfg = colCfgMapping?.[dataItemDate];
          const {
            cardsNumPerRow: dateItemColCardsNumPerRow = 0,
            width: dataItemColWidth = 0,
            cardWidth: dataItemCardWidth = 0,
          } = dataItemColCfg || {};

          return (
            <div
              key={getCalendarPanelCardListKey(dataItemDate)}
              className={classnames('dbg-item-col', { 'current-time-col': isCurrentTimeCol })}
              style={{
                marginRight: getCalendarColMR?.(dataItemIdx),
                flex: `0 0 ${dataItemColWidth}px`,
                width: dataItemColWidth,
              }}
            >
              <div className="dbg-item-col-space">
                <div className="dbg-card-group">
                  {/* 无数据的日历卡片 */}
                  {showCalendarCardList || <CalendarNoDataCard />}
                  {/* 有数据的日历卡片 */}
                  {showCalendarCardList &&
                    dataItemList?.map((subDataItem, subDataItemIdx) => {
                      // 折叠状态下，隐藏超过MAX_ROW_NUM配置的行数的日历卡片
                      if (fold && subDataItemIdx > dateItemColCardsNumPerRow * MAX_ROW_NUM - 1)
                        return null;
                      const {
                        id,
                        project_id: projectId,
                        studio,
                        milestone,
                        type: subDataItemType,
                        isTBC: subDataItemIsTBC,
                        isExpire: subDataItemIsExpire,
                      } = subDataItem || {};
                      const sudDataItemUniqueId = `${projectId}@${studio}@${milestone}@${id}@${subDataItemIdx}`;
                      return (
                        <Card
                          key={getCalendarPanelCardListItemKey(dataItemDate, sudDataItemUniqueId)}
                          style={{
                            marginRight: getCalendarCardMR?.(dataItemDate, subDataItemIdx),
                            width: dataItemCardWidth,
                          }}
                          fullScreenContent={fullScreenContent}
                          isStudioCalendar={isStudioCalendar}
                          isDashboardCalendar={isDashboardCalendar}
                          // @ts-ignore
                          type={subDataItemType}
                          // @ts-ignore
                          isTBC={subDataItemIsTBC}
                          // @ts-ignore
                          isOverdue={subDataItemIsExpire}
                          cardList={subDataItem}
                          onCardClick={onCardClick}
                        />
                      );
                    })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// @ts-ignore
export default React.memo(React.forwardRef(CalendarPanelCardList));
